import React from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { useTabConfig } from './hooks/useTabConfig';

interface FilterInfoProps {

}

export const FilterInfo: React.FC<FilterInfoProps> = () => {
    const [showPopup, setShowPopup] = React.useState(false);
    const tabConfig = useTabConfig();


    // Example structure, adjust according to your useTabConfig() return value
    // config = {
    //   filters: {
    //     Status: ['New', 'Late', 'Current'],
    //     Priority: ['High', 'Medium'],
    //     State: ['Open', 'Closed'],
    //   }
    // }

    const filterEntries = { "Priority": tabConfig?.priorityNames || [], "Status": tabConfig?.statusNames || [], "State": tabConfig?.states || [] }


    const filterCount = Object.values(filterEntries).reduce(
        (acc, values) => acc + (values && values.length > 0 ? 1 : 0),
        0
    );

    const uRef = React.useRef(null);

    if (filterCount === 0) return <i>{tabConfig?.priorityNames?.map(p => <div key={p}>{p}</div>)}</i>;

    return (
        <div className='d-flex align-items-center position-relative' ref={uRef}

            onMouseEnter={() => setShowPopup(true)}
            onMouseLeave={() => setShowPopup(false)}
        >
            <u className='ms-2' style={{ cursor: 'pointer', fontWeight: 500 }}>
                ({filterCount} Filter{filterCount > 1 ? 's' : ''})
            </u>
            <Popup

                anchorAlign={{ horizontal: 'right', vertical: 'bottom' }}
                show={showPopup}
                anchor={uRef.current}
                appendTo={uRef.current}
                popupClass="k-tooltip"
                style={{ left: 0, top: 24, zIndex: 1000 }}
            >
                <div style={{ padding: '8px 12px', minWidth: 180 }}>
                    {filterCount === 0 ? (
                        <div>No filters applied.</div>
                    ) : (
                        Object.entries(filterEntries).map(([key, values]) => (
                            values && values.length > 0 && (
                                <div key={key} style={{ marginBottom: 4 }}>
                                    <strong>{key}:</strong>{' '}
                                    {Array.isArray(values) ? values.join(', ') : values}
                                </div>)
                        ))
                    )}
                </div>
            </Popup>
        </div>
    );
};

export default FilterInfo;